export class TerritoryFilterModel {
  public id: number;
  public label: string;
  public codeISO: string;
  public listIdParent: number[];
}
